import React,{useRef} from 'react';
import ReactHlsPlayer from 'react-hls-player';

function MyCustomComponent({src,height}) {
  const playerRef = useRef();

//   function playVideo() {
//     playerRef.current.play();
//   }

//   function pauseVideo() {
//     playerRef.current.pause();
//   }

//   function toggleControls() {
//     playerRef.current.controls = !playerRef.current.controls;
//   }


  return (
    <video
      // playerRef={playerRef}
      src={src}
      controls
      autoPlay
      muted
    />
  );
}

export default MyCustomComponent;

